import { z } from 'zod'

export class HttpError extends Error {
  constructor(
    public readonly method: z.infer<typeof methodSchema>,
    public readonly url: string,
    public readonly status: number,
    public readonly textResult: string,
  ) {
    super(`Failed ${method} ${url}: ${status} - ${textResult}`)
    this.name = 'HttpError'
  }
}

export const methodSchema = z.union([z.literal('GET'), z.literal('POST'), z.literal('DELETE')])
